export default __webpack_public_path__ + "static/media/40.1642fd97.png";